import { FaArrowLeft } from "react-icons/fa";

export default function DetailHeader({
  onGoBack,
  backLabel = "Geri",
  backTitle,
  backContent,
  children,
}) {
  return (
    <div className="relative bg-gradient-to-r from-slate-50 via-blue-50 to-indigo-50 px-3 py-2.5 sm:px-5 sm:py-4 border-b border-gray-200 shrink-0">
      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
        <div className={`flex ${backContent ? "items-stretch" : "items-center"} gap-2 sm:flex-1 sm:min-w-0`}>
          <button
            onClick={onGoBack}
            className={
              backContent
                ? "inline-flex items-center justify-center px-2.5 sm:px-3 py-1 bg-white rounded-lg sm:rounded-xl border border-gray-200 hover:border-blue-300 shadow-sm transition-all text-gray-600 hover:text-blue-600 shrink-0 self-stretch"
                : "inline-flex items-center gap-2 px-2.5 py-2 sm:px-4 sm:py-2.5 bg-white rounded-lg sm:rounded-xl border border-gray-200 hover:border-blue-300 shadow-sm transition-all text-gray-600 hover:text-blue-600 shrink-0 text-sm sm:text-base font-medium"
            }
            title={backTitle || backLabel}
          >
            {backContent || (
              <>
                <FaArrowLeft className="w-5 h-5" />
                <span>{backLabel}</span>
              </>
            )}
          </button>
          {children}
        </div>
      </div>
    </div>
  );
}
